import { render, staticRenderFns } from "./BpWorkingCapitalToTotalAssetsDisplayer.vue?vue&type=template&id=74b79410"
import script from "./BpWorkingCapitalToTotalAssetsDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpWorkingCapitalToTotalAssetsDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports